import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {InstagramService} from 'src/app/services/social/instagram.service';

@Component({
  selector: 'app-instagram-post',
  templateUrl: './instagram-post.component.html',
})
export class InstagramPostComponent implements OnInit, OnDestroy {
  media: any = {};
  comments: any = [];
  pendingDeleteId;
  deletingId;
  igCommentsLoading = false;
  currentSlide = 0;
  postLiked = false;
  showEmojiPicker = false;
  newCommentText = '';
  replyingToComment: any = null;
  accountDetails: any = {};
  emojiList = [
    '😀', '😂', '😍', '😎', '😭', '😤', '😊', '🥰',
    '😅', '😆', '🤣', '😇', '🥳', '😏', '😒', '😓',
    '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍',
    '🔥', '✨', '💯', '🎉', '👏', '🙌', '👍', '👎',
    '😢', '😩', '🤔', '🤩', '😋', '😜', '🤪', '😝',
    '🙏', '💪', '🫶', '👀', '💀', '🫠', '😤', '🥲',
    '🚀', '🌟', '💫', '⚡', '🎯', '💥', '🌈', '🎊',
  ];
  @ViewChild('videoElement') videoElement: ElementRef;
  @ViewChild('commentInputRef') commentInputRef: ElementRef;
  @ViewChild('commentsScroll') commentsScroll: ElementRef;
  private postSubscription: Subscription;

  constructor(private instagramService: InstagramService) {
    instagramService.instagramDetails().subscribe(
      response => {
        this.accountDetails = response.data.payload;
      }
    );
  }

  ngOnInit() {
    this.postSubscription = this.instagramService.postToView.subscribe((post: any) => {
      if (!Object.keys(post).length) {
        return;
      }
      this.instagramService.fetchComments(post.id).subscribe((comments: any) => {
        this.comments = (comments.data.payload || []).map((c: any) => ({
          ...c,
          liked: false,
          showReplies: false,
          replies: (c.replies && c.replies.data ? c.replies.data : []).map((r: any) => ({
            ...r,
            liked: false,
          })),
        }));
      });
      this.media = post;
      this.openPostModal();
    });

  }

  openPostModal() {
    document.getElementById('instagramPostModalBtn').click();
  }

  ngOnDestroy() {
    if (this.postSubscription) {
      this.postSubscription.unsubscribe();
    }
  }

  onCloseModal() {
    this.media = {};
    this.comments = [];
    this.instagramService.postToView.next({});
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide = this.currentSlide - 1;
    }
  }

  nextSlide() {
    if (this.currentSlide < (this.media.children.data.length - 1)) {
      this.currentSlide = this.currentSlide + 1;
    }
  }

  gotoSlide(i: number) {
    this.currentSlide = i;
  }

  get activeMedia() {
    if (this.media.media_type === 'CAROUSEL_ALBUM' && this.media.children.data.length) {
      return this.media.children.data[this.currentSlide];
    }
    return this.media;
  }


  replyTo(comment: any) {
    this.replyingToComment = comment;
    // pre-fill with @username
    this.newCommentText = `@${comment.username} `;
    // focus input
    setTimeout(() => this.commentInputRef.nativeElement.focus(), 100);
  }

  timeAgo(timestamp: string): string {
    const now = new Date();
    const date = new Date(timestamp);
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) {
      return 'Just now';
    }
    if (minutes === 1) {
      return '1 minute ago';
    }
    if (minutes < 60) {
      return `${minutes} minutes ago`;
    }
    if (hours === 1) {
      return '1 hour ago';
    }
    if (hours < 24) {
      return `${hours} hours ago`;
    }
    if (days === 1) {
      return 'Yesterday';
    }
    if (days === 2) {
      return '2 days ago';
    }

    // after 2 days return formatted date
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  submitComment() {
    console.log('submitting comment...');
    const text = this.newCommentText.trim();
    if (!text) {
      return;
    }

    if (this.replyingToComment) {
      this.instagramService.replyComment(this.replyingToComment.id, text)
        .subscribe({
          next: (res: any) => {
            // optimistic update
            console.log({res});
            if (!this.replyingToComment.replies) {
              this.replyingToComment.replies = [];
            }
            this.replyingToComment.replies.push({
              id: res.data.id || Date.now(),
              username: this.accountDetails.username,
              text,
              timestamp: new Date().toISOString(),
              liked: false,
            });
            this.replyingToComment.showReplies = true;
            this.replyingToComment = null;
            this.newCommentText = '';
            this.scrollToBottom();
          },
          error: (err) => {
            console.error('reply failed', err);
          }
        });
    } else {
      this.instagramService.postComment(text, this.media.id).subscribe((comment: any) => {
        this.comments = [{
          id: comment.data.payload.id, username: this.accountDetails.username || 'You', text,
          timestamp: this.getIgFormattedDate(), like_count: 0, liked: false,
          showReplies: false, replies: []
        }, ...this.comments
        ].sort((a, b) => a.timestamp - b.timestamp);

      });

    }

    this.newCommentText = '';
    setTimeout(() => {
      const el = this.commentsScroll.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    }, 50);
  }

  cancelReply() {
  }

  getIgFormattedDate(date = new Date()) {
    return date.toISOString().replace(/\.\d{3}Z$/, '+0000');
  }

  scrollToBottom() {
    setTimeout(() => {
      const el = this.commentsScroll.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    }, 50);
  }

  deleteComment(comment: any) {
    console.log('deleted comment...');
    this.deletingId = comment.id;
    this.instagramService.deleteComment(comment.id).subscribe({
      next: () => {

        this.comments = this.comments.filter((c: any) => c.id !== comment.id);
        this.deletingId = null;
        this.pendingDeleteId = null;
      },
      error: (err) => {
        console.error('deleted comment failed', err);
        this.deletingId = null;
        this.pendingDeleteId = null;
      }
    });
  }

  deleteReply(parent: any, reply: any) {
    this.deletingId = reply.id;
    this.instagramService.deleteComment(reply.id).subscribe({
      next: () => {
        parent.replies = parent.replies.filter((r: any) => r.id !== reply.id);
        this.deletingId = null;
        this.pendingDeleteId = null;
      },
      error: (err) => {
        this.deletingId = null;
        this.pendingDeleteId = null;
        console.error('delete reply failed', err);
      }
    });
  }
  confirmDelete(id: string): void {
    this.pendingDeleteId = id;
  }
  cancelDelete(): void {
    this.pendingDeleteId = null;
  }
  canDelete(comment: any): boolean {
    return comment.username === this.accountDetails.username;
  }

  getInitials(username: string): string {
    if (!username) {
      return 'IG';
    }
    return username.slice(0, 2).toUpperCase();
  }

  toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  selectEmoji(emoji: string) {
    this.newCommentText = (this.newCommentText || '') + emoji;
    this.showEmojiPicker = false;
    setTimeout(() => this.commentInputRef.nativeElement.focus(), 50);
  }
}

